import toLower from 'lodash/toLower'

import { apiSlice } from 'api/apiSlice'
import {
  AvailablePaymentMethods,
  PaymentAvailabilityRequest,
  PaymentAvailabilityResponse,
} from 'shared/types/PaymentAvailability'

const paymentAvailabilityApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPaymentAvailability: build.query<AvailablePaymentMethods, PaymentAvailabilityRequest>({
      query: (body) => ({
        app: 'peas',
        data: body,
        method: 'POST',
        url: `/web-api/v1/payments_availability/list_available_payment_methods`,
      }),
      transformResponse: (response: PaymentAvailabilityResponse): AvailablePaymentMethods => {
        if (!response?.paymentMethods || response?.paymentMethods?.length === 0) return {}

        const availablePaymentMethods: AvailablePaymentMethods = {}

        for (const paymentMethod of response.paymentMethods) {
          availablePaymentMethods[toLower(paymentMethod.name) as keyof AvailablePaymentMethods] =
            paymentMethod
        }

        return availablePaymentMethods
      },
    }),
  }),
})

export const { useGetPaymentAvailabilityQuery } = paymentAvailabilityApi
